import { Button, PanelContent, TextField } from '@deque/cauldron-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { UserAccessChanges } from '~/app/containers/UserManagement';
import { type EnterpriseMembers } from '~/common/utils/billing-client/client-v2';
import styles from './ReviewStep.css';

export interface ReviewStepProps {
  selectedMembers: EnterpriseMembers.AcceptedMember[];
  userAccessChanges: UserAccessChanges;
  handlePreviousStep: () => void;
  handleSubmit: () => void;
}

const ReviewStep = ({
  selectedMembers,
  userAccessChanges,
  handlePreviousStep,
  handleSubmit
}: ReviewStepProps) => {
  const { t } = useTranslation();

  return (
    <>
      <PanelContent>
        <TextField
          value={selectedMembers
            .map(
              member =>
                `${member.first_name} ${member.last_name} (${member.email})`
            )
            .join('\n')}
          multiline
          readOnly
          label={t('Selected Users ({{userCount}})', {
            userCount: selectedMembers.length
          })}
          className={styles.userList}
        />
        <h3>{t('Access Changes')}</h3>
        <ul className={styles.accessChangesList}>
          {userAccessChanges.grantGeneralProducts.map(product => (
            <li key={product.slug}>
              {t('Added {{productName}} (General)', {
                productName: product.name
              })}
            </li>
          ))}
          {userAccessChanges.grantAdminProducts.map(product => (
            <li key={product.slug}>
              {t('Added {{productName}} (Admin)', {
                productName: product.name
              })}
            </li>
          ))}
          {userAccessChanges.grantViewProducts.map(product => (
            <li key={product.slug}>
              {t('Added {{productName}} (View)', {
                productName: product.name
              })}
            </li>
          ))}
          {userAccessChanges.removeProducts.map(product => (
            <li key={product.slug}>
              {t('Removed {{productName}}', { productName: product.name })}
            </li>
          ))}
        </ul>
      </PanelContent>
      <PanelContent className={styles.buttonContainer}>
        <div className={styles.buttonGroup}>
          <Button variant="secondary" onClick={handlePreviousStep}>
            {t('Back')}
          </Button>
          <Button type="submit" variant="primary" onClick={handleSubmit}>
            {t('Finish')}
          </Button>
        </div>
        <Link to="/user-access" className="Link">
          {t('Cancel')}
        </Link>
      </PanelContent>
    </>
  );
};

export default ReviewStep;
